
























import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import DeviceMethods from '@/mixins/DeviceMethods.vue';

@Component({
    name: 'TenantsMobileFooter',
})
export default class TenantsMobileFooter extends Mixins(DeviceMethods) {
    constructor() {
        super();
    }

    public toggleMobileAside(e: any) {
        e.navigate = false;

        this.shelfVisible ? this.$store.dispatch(Actions.HIDE_SHELF) : this.$store.dispatch(Actions.SHOW_SHELF);
    }

    public openAssistant(e: any) {
        e.navigate = false;

        this.$store.commit(Mutations.SET_HOME_ASSISTANT_VISIBILITY, true);
    }
}
